<template>
 
  <div class="pb-100 ">
    <div class="container">
      <div class="section-title mw-600">
        <span class="top-title">Our Celebrities</span>
        <h2>Exclusively shining with us — only on MyCelebrity.</h2>
      </div>

      <swiper
        :spaceBetween="25"
        :slidesPerView="1"
        :preventClicks="true"
        :loop="true"
        :autoplay="{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        :navigation="{
          nextEl: '.next',
          prevEl: '.prev',
        }"
        :modules="modules"
        class="testimonial-slide testimonials-wrappers"
      >
        <swiper-slide v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <div
                class="testimonial-img position-relative mb-4 mb-lg-0 d-inline-block"
              >
                <img title="We connect brands with celebrities and influencers for powerful digital campaigns." :src="testimonial.image" alt="testimonials" />
               
              </div>
            </div>
            <div class="col-lg-8">
              <div class="testimonial-quot">
                <p>{{ testimonial.description }}</p>
                <div class="testimonial-info ms-0 text-start">
             <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">{{ testimonial.name }}</h3>
                  <span>{{ testimonial.designation }}</span> 
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
<div class="button-row">
      <router-link to="/get-your-wish" class="btn btn-primary get-wish-btn">
        Get your Wish
      </router-link>
      <router-link to="/business-enquiry" class="btn btn-primary get-wish-btn">
        Business Enquiry
      </router-link>
    </div>
  
  </div>
</template>


<script lang="ts">
import { defineComponent } from "vue";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default defineComponent({
  name: "TestimonialsContent",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          image: require("../../assets/images/rashmi.jpg"),
          description:
            "Rashmi Prabhakar is a well-known Kannada television actress who rose to fame with her lead role as Lachi/Chinnu in the hit serial Lakshmi Baramma. She has also worked in Telugu and Tamil TV industries, starring in shows like Pournami, Arundhati, and Krishna Mukunda Murari. Rashmi made her film debut with BB5 and appeared in the mythological film Mahakavya. Known for her versatility and strong screen presence, she won the reality show Super Queen in 2023 and married Nikhil Bhargav in 2022.",
          name: "Rashmi Prabhakar",
        designation: "Kannada Actress",
        },
       
      ],
    };
  },
  setup() {
    return {
      Autoplay,
      modules: [Navigation],
    };
  },
});
</script>

<style lang="scss" scoped>
.pb-100 {
  padding-top: 100px;
}
.testimonials-wrappers {
  max-width: 1096px;
  margin: auto;
}
.button-row {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-right: 170px;
  margin-top: -44px;
}
@media (max-width: 767px) {
  .button-row {
    flex-direction: column;
    align-items: stretch;
    margin-right: 0;
    margin-top: 16px;
    gap: 12px;
  }
}
  .get-wish-btn {
    font-size: 18px;
    padding: 12px 32px;
    border-radius: 30px;
    background: #ff5a5f;
    color: #fff;
    border: none;
    transition: background 0.2s;
  margin-top: 0px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(255,90,95,0.15);
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .get-wish-btn:hover {
    background: #e14b50;
    color: #fff;
    box-shadow: 0 4px 16px rgba(255,90,95,0.18);
  }
.testimonial-quot {
  margin-left: 64px;
  p {
    font-weight: 500;
    line-height: 30px;
    font-size: 18px;
    color: #4c4c4c;
    font-style: italic;
    margin-bottom: 40px;
  }
}
.testimonial-img {
  .top-0 {
    top: 50px !important;
  }
  .end {
    right: -10px !important;
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .testimonial-quot {
    margin-left: 0;
  }
}
/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-quot {
    margin-left: 0;
  }
}
</style>